"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _parseFloat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/number/parse-float"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./RatingDisplaySingleStar.scss");
var _fullStar = _interopRequireDefault(require("./assets/full-star"));
var RatingDisplaySingleStar = function RatingDisplaySingleStar(_ref) {
  var rating = _ref.rating,
    customId = _ref.customId,
    customClass = _ref.customClass,
    starSize = _ref.starSize,
    ratingFontSize = _ref.ratingFontSize,
    ratingLocation = _ref.ratingLocation,
    roundRating = _ref.roundRating,
    showRating = _ref.showRating;
  var normalizedRating;
  var displayRating;
  if (rating) {
    if (rating > 5.0) {
      normalizedRating = 5.0;
    } else if (rating < 0) {
      normalizedRating = 0.0;
    } else {
      normalizedRating = (0, _parseFloat["default"])(rating.toFixed(1));
    }
    if (roundRating) {
      displayRating = Math.round(normalizedRating);
    } else {
      displayRating = normalizedRating.toFixed(1);
    }
  } else {
    normalizedRating = 0.0;
    displayRating = 'N/A';
  }
  var ratingLocationInternal = ratingLocation || 'right';
  var starSizeInternal = starSize || '2em';
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: customId,
    className: customClass
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "Rating-Display-Single-Star-Wrapper",
    className: "star-ratings"
  }, ratingLocationInternal === 'left' && showRating ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "rating-number",
    style: {
      fontSize: ratingFontSize
    }
  }, displayRating) : null, /*#__PURE__*/_react["default"].createElement(_fullStar["default"], {
    size: starSizeInternal,
    key: "full-star"
  }), ratingLocationInternal !== 'left' && showRating ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "rating-number",
    style: {
      fontSize: ratingFontSize
    }
  }, displayRating) : null));
};
RatingDisplaySingleStar.propTypes = {
  rating: _propTypes["default"].number,
  roundRating: _propTypes["default"].bool,
  showRating: _propTypes["default"].bool,
  customId: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  starSize: _propTypes["default"].string,
  ratingFontSize: _propTypes["default"].string,
  ratingLocation: _propTypes["default"].string
};
RatingDisplaySingleStar.defaultProps = {
  rating: undefined,
  roundRating: false,
  showRating: true,
  customId: '',
  customClass: '',
  starSize: '2em',
  ratingFontSize: '1.2em',
  ratingLocation: 'right'
};
var _default = exports["default"] = RatingDisplaySingleStar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/RatingDisplaySingleStar.js
// module id = 953
// module chunks = 25